import { API_ENDPOINT } from './config.js';

// Shown when fetch itself rejects, i.e. the request never produced an HTTP response.
// A response the browser blocks for CORS also lands here, and on this backend that
// usually means the proxy answered rather than Django: an Apache/gunicorn error page
// carries no Access-Control-Allow-Origin, so the browser hides it and fetch rejects.
export const NETWORK_ERROR_MESSAGE =
  'Could not reach the server — the request may have timed out. Please try again.';

async function apiHelper(action, method = 'GET', data = null, content = 'application/json') {

   	const url = `${API_ENDPOINT}/${action}`;
   	const token = localStorage.getItem('token');

    const body = content == 'application/json' ? JSON.stringify(data) : data
    let options = {
        method: method,
        headers: {
          'Authorization': `Token ${token}`,
          'Content-Type': 'application/json'
        }
    }

    if(data){
        let headers = {
            'Authorization': `Token ${token}`,
            'Content-Type': 'application/json'
        };

        if(content != 'application/json'){
          headers = {
            'Authorization': `Token ${token}`
          } 
        }
        options = {
          method: method,
          headers: headers,
          body : body,
        }
    }
   
    try {
       const response = await fetch(url, options);
       return response;
     } catch (error) {
       // A rejected fetch used to fall out of here as `undefined`. Callers uniformly
       // test `res.ok` and then read a message off the body, so a transport failure was
       // indistinguishable from a rejected request and surfaced as whatever hardcoded
       // fallback the caller happened to carry. Hand back a synthetic failed response:
       // every existing `res && res.ok` / `!res || !res.ok` check behaves exactly as
       // before, but `res.json()` now yields something worth showing the user.
       console.error('API Error:', error);
       return {
         ok: false,
         status: 0,
         statusText: 'Network Error',
         networkError: true,
         json: async () => ({ message: NETWORK_ERROR_MESSAGE }),
         text: async () => NETWORK_ERROR_MESSAGE,
         blob: async () => new Blob([]),
       };
     }
}

export default apiHelper;